import { useMemo } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Button, Form, message, Result } from 'antd';
import { IoArrowBack } from 'react-icons/io5';
import cloneDeep from 'lodash/cloneDeep';
import Box from 'src/components/Box';
import apiRequests from 'src/utils/api';
import apiRoutes from 'src/utils/apiRoutes';
import FormButtons from 'src/components/FormBuilder/FormButtons';
import RequestForm from './RequestForm';
import useRequestFormActions from './useRequestFormActions';
import { useSelector } from 'react-redux';
import { RootState } from 'src/store';

const RequestCreatePage = () => {
  const listForms = useSelector(
    (state: RootState) => state.resources.requestForms
  );

  const [form] = Form.useForm();

  const params = useParams();
  const navigate = useNavigate();

  const formBuilder = useMemo(() => {
    const newFormBuilder = cloneDeep(
      listForms.find((item) => item.id === parseInt(params.id ?? '0'))
    );

    if (newFormBuilder && newFormBuilder.form && newFormBuilder.deliverables) {
      const listItemHtml = newFormBuilder.deliverables
        .map((deliverable: string) =>
          deliverable ? `<li>${deliverable}</li>` : ''
        )
        .filter((html: string) => html);

      if (listItemHtml.length > 0) {
        const listItemsString = listItemHtml.join('');

        const answerHtmlString = `<b>Deliverables:</b><ul>${listItemsString}</ul>`;

        const projectBriefField = newFormBuilder.form.find(
          (field: any) => field.name === 'project_brief'
        );

        if (projectBriefField) {
          projectBriefField.answer = answerHtmlString;
        }
      }
    }

    return newFormBuilder;
  }, [params.id, listForms]);

  const saveRequest = async (values: any) => {
    const response = await apiRequests.post(apiRoutes.PROJECT_REQUEST, values);

    if (response.data.data.status === 'draft') {
      message.success('Draft created');
    } else {
      message.success('Request submitted');
    }

    navigate(`/requests/${response.data.data.uuid}`);

    return response.data.data;
  };

  const { saving, onDraft, onSubmit } = useRequestFormActions({
    form,
    formBuilder,
    onDraft: saveRequest,
    onSubmit: saveRequest,
  });

  return (
    <div>
      <div className="mb-2 flex flex-wrap items-center justify-between overflow-hidden">
        <Button
          type="link"
          size="large"
          icon={<IoArrowBack />}
          style={{ paddingLeft: 0 }}
          onClick={() => {
            navigate('/requests/create');
          }}
        >
          Go back
        </Button>

        <FormButtons
          form={form}
          saving={saving}
          onDraft={onDraft}
          onSubmit={onSubmit}
        />
      </div>

      <Box>
        {formBuilder ? (
          <RequestForm
            form={form}
            formBuilder={formBuilder}
            saving={saving}
            footer={
              <FormButtons
                form={form}
                saving={saving}
                onDraft={onDraft}
                onSubmit={onSubmit}
                showSavingLoading
              />
            }
            confirmBeforeRedirect
            header
          />
        ) : (
          <Result status="404">Not found</Result>
        )}
      </Box>
    </div>
  );
};

export default RequestCreatePage;
